import { combineReducers } from "redux";

import user from "./user.reducer";
import loader from "./loader.reducer";
import create from "./create.reducer";
import compare from "./compare.reducer";
import retirement from "./retirement.reducer";
import layout from "./layout.reducer";
import iqciolive from "./iqciolive.reducer";
import myPortfolios from "./myPortfolios.reducer";
import buildPortfolio from "./buildPortfolio.reducer";
import myClients from "./myClients.reducer";

export default combineReducers({
  user,
  loader,
  create,
  compare,
  retirement,
  layout,
  iqciolive,
  myPortfolios,
  buildPortfolio,
  myClients,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js